import { Controller } from "@hotwired/stimulus"
import { play, stop, subscribe } from "../lib/audio_preview_bus"

// A band card in the grid, working as a remote for the one player on the page (#124). It has no
// <audio> of its own - it hands the "teraz gra" bar a src, a name and a profile URL, and
// subscribes to find out whether it is the card currently playing.
//
// Playing starts on a press and on nothing else. Hovering a card used to start it; the call was
// reversed, because a grid that makes noise at whatever the mouse passes over is startling rather
// than helpful. Nothing here listens to the pointer, and a phone is the same interaction as a
// desktop: the button plays, the rest of the card opens the profile.
//
// Enhancement only: the control it drives is a link to the profile, which is where a real
// <audio controls> is. Without JavaScript, clicking it goes there.
export default class extends Controller {
  static targets = ["toggle", "playIcon", "pauseIcon", "label", "progress", "fill"]
  static values = {
    token: String,
    src: String,
    name: String,
    href: String,
    playLabel: String,
    pauseLabel: String
  }

  connect() {
    this.unsubscribe = subscribe((state) => this.#update(state))
  }

  disconnect() {
    this.unsubscribe?.()
  }

  // The control is a link to the profile; with JS it plays instead. A modified click (new tab,
  // new window) is left alone - somebody asking for the profile page should get it.
  toggle(event) {
    if (event && (event.metaKey || event.ctrlKey || event.shiftKey || event.button > 0)) return

    event?.preventDefault()

    if (this.current && this.playing) {
      stop()
    } else {
      play({
        token: this.tokenValue,
        src: this.srcValue,
        name: this.nameValue,
        href: this.hrefValue
      })
    }
  }

  #update({ token, playing, progress }) {
    this.current = token === this.tokenValue
    this.playing = this.current && playing

    const label = this.playing ? this.pauseLabelValue : this.playLabelValue

    this.playIconTarget.classList.toggle("hidden", this.playing)
    this.pauseIconTarget.classList.toggle("hidden", !this.playing)
    this.labelTarget.textContent = label
    this.toggleTarget.setAttribute("title", label)
    this.progressTarget.classList.toggle("hidden", !this.current)
    this.fillTarget.style.width = this.current ? `${Math.round(progress * 100)}%` : "0%"
  }
}
